import React from 'react';
import Message from './Message';
import './MessageList.css';

const MessageList = ({ messages, botAvatar, messagesEndRef }) => {
  return (
    <div className="message-list">
      <div className="messages-container">
        {messages.map((message) => (
          <Message key={message.id} message={message} botAvatar={botAvatar} />
        ))}
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
};

export default MessageList;

